;$(function () {
  'use strict'

  var horizontalScrollSelector = '[data-horizontal-scroll]'
  var horizontalScrollInnerSelector = '[data-horizontal-scroll-inner]'
  var leftArrowSelector = '[data-horizontal-scroll-arrow-left]'
  var rightArrowSelector = '[data-horizontal-scroll-arrow-right]'
  var duration = 400
  var scrollAmount = 540

  $(horizontalScrollSelector).each(function () {
    var $this = $(this)
    var size = $this.outerWidth()
    var innerSize = $this.find(horizontalScrollInnerSelector).outerWidth(true)

    if (innerSize > size) {
      $this.parent().find(rightArrowSelector).removeClass('layout__none')
    }

    $this.on('scroll', function () {
      var position = $this.scrollLeft()
      var invisibleSize = innerSize - size

      if (position <= 0) {
        $this.parent().find(leftArrowSelector).addClass('layout__none')
        $this.parent().find(rightArrowSelector).removeClass('layout__none')
      }
      else if (position < invisibleSize) {
        $this.parent().find(leftArrowSelector).removeClass('layout__none')
        $this.parent().find(rightArrowSelector).removeClass('layout__none')
      }
      else if (position >= 0) {
        $this.parent().find(leftArrowSelector).removeClass('layout__none')
        $this.parent().find(rightArrowSelector).addClass('layout__none')
      }
    })

    $this.parent().find(leftArrowSelector).on('click', function () {
      $this.parent().find(horizontalScrollSelector).animate({
        scrollLeft: '-=' + scrollAmount + 'px'
      }, duration)
    })
    $this.parent().find(rightArrowSelector).on('click', function () {
      $this.parent().find(horizontalScrollSelector).animate({
        scrollLeft: '+=' + scrollAmount + 'px'
      }, duration)
    })
  })
})
